/**
 * 系统调用组件
 * zxw
 * 创建时间 2026-05-11
 */


// 注册方法
const methods = [
    { name: '获取当前日期', value: 'SysCurrentDate', returnType: 'string', description: `获取系统当前日期，返回格式为：YYYY-MM-DD` },
    { name: '获取当前时间', value: 'SysCurrentTime', returnType: 'string', description: '获取系统当前时间，返回格式为：YYYY-MM-DD HH:mm:ss' },
];

const SysCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const SysCurrentTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const SysCall = {
    SysCurrentDate,
    SysCurrentTime,
    methods,
};